<template>
  <div>
    <!-- 头 -->
    <aheader></aheader>
    <!-- 內容 -->
    <div class="section">
      <!-- 左边导航 -->
      <div class="side-bar pull-left">
        <ul>
          <template v-for="item in fnList">
            <li :class="{ 'cur-bg': currentSideBar === item.id }" @click="saveSideBar(item.id, item.link)" v-if="allList || fnListKeys.includes(item.id)" :key="item.id">
              <i :class="item.icon" aria-hidden="true"></i>
              {{ item.text }}
            </li>
          </template>

          <li @click="logoutFn">
            <i aria-hidden="true" class="fa fa-power-off"></i>
            {{ mainViewLan.sidebarList.logout }}
          </li>
        </ul>
      </div>
      <!-- 中间内容部分 -->
      <div class="content-view pull-left">
        <crumbs :activeItem="activeItem" :desc="desc" :login="managerAccount" @exit="exit"></crumbs>
        <router-view :viewReadOnly="viewReadOnly" class="content-box" />
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import aheader from 'components/aHeader'
import crumbs from 'components/crumbs'
import { URL_LIST, URL_LOGOUT, URL_TIMEDIFF } from 'api/api.js'
export default {
  components: {
    aheader,
    crumbs,
  },
  mixins: [require('common/mixin/base.js').base({ mainViewLan: 'mainView' })],
  data() {
    return {
      fnListKeys: [], // 存储当前role对应的fuction
      allList: false, // 如果当前role有所有的function则为true
      currentSideBar: '',
      responseFnlist: [],
      managerLogin: '',
    }
  },
  computed: {
    fnList() {
      // 目前页面上所有的侧边导航
      let sider = this.mainViewLan.sidebarList
      return [
        { text: sider.dayTradeReport, id: 'FN_REPORT1', link: '/dayTradeReport', icon: 'fa fa-list', childrenLink: [] },
        { text: sider.positionReport, id: 'FN_REPORT2', link: '/positionReport', icon: 'fa fa fa-th', childrenLink: [] },
        { text: sider.bBookReport, id: 'FN_REPORT3', link: '/bBookReport', icon: 'fa fa-th-list', childrenLink: [] },
        { text: sider.clientReport, id: 'FN_CLIENT_REPORT', link: '/clientReport', icon: 'fa fa-table', childrenLink: [] },
        { text: sider.closedTradesReport, id: 'FN_CLOSED_TRADES_REPORT', link: '/closedTradesReport', icon: 'fa fa-money', childrenLink: [] },
        { text: sider.monitorAccounts, id: 'FN_MONITOR_ACCOUNTS', link: '/monitorAccountsReport', icon: 'fa fa-eye', childrenLink: [] },
        { text: sider.managerOperateRecord, id: 'FN_MANAGER_OPERATE_LOG', link: '/managerOperateRecord', icon: 'fa fa-book', childrenLink: [] },
        { text: sider.loginRecord, id: 'FN_LOGIN_RECORD', link: '/loginRecord', icon: 'fa fa-book', childrenLink: [] },
        { text: sider.autoPositionReportConfig, id: 'FN_POSITION_REPORT_CONFIG', link: '/autoPositionReport', icon: 'fa fa-book', childrenLink: [] },
        { text: sider.autoUpdateLeverage, id: 'FN_UPDATE_LEVERAGE_CONFIG', link: '/autoUpdateLeverage', icon: 'fa fa-book', childrenLink: [] },
        { text: sider.chargeDividends, id: 'FN_CHARGE_DIVIDENDS_CONFIG', link: '/chargeDividends', icon: 'fa fa-book', childrenLink: [] },
        { text: sider.annualInterestBonus, id: 'FN_ANNUAL_INTEREST_CONFIG', link: '/annualInterestBonus', icon: 'fa fa-book', childrenLink: [] },
        { text: sider.floatingPL, id: 'FN_FLOATING_PL', link: '/floatingPLReport', icon: 'fa fa-university', childrenLink: [] },
        { text: sider.openTradeStat, id: 'FN_OPEN_TRADES', link: '/openTradesReport', icon: 'fa fa-plus', childrenLink: [] },
        { text: sider.accountAnalyze, id: 'FN_ACCOUNT_ANALYZE', link: '/accountAnalyzeReport', icon: 'fa fa-users', childrenLink: [] },
        { text: sider.symbolProfit, id: 'FN_SYMBOL_PROFIT', link: '/symbolProfitReport', icon: 'fa fa-bar-chart', childrenLink: [] },
        { text: sider.profitTopList, id: 'FN_PROFIT_TOP_LIST', link: '/profitTopList', icon: 'fa fa-trophy', childrenLink: [] },
        { text: sider.downloadReport, id: 'FN_DOWNLOAD_REPORT', link: '/downloadReport', icon: 'fa fa-download', childrenLink: [] },
        { text: sider.mt4ClosedTradesReport, id: 'FN_MT4_CLOSED_TRADES_REPORT', link: '/mt4ClosedTradesReport', icon: 'fa fa-area-chart', childrenLink: [] },
        { text: sider.mt4DepositWithdrawlReport, id: 'FN_MT4_DEPOSIT_WITHDRAWL_REPORT', link: '/mt4DepositWithdrawlReport', icon: 'fa fa-line-chart', childrenLink: [] },
        { text: sider.mt4CreditReport, id: 'FN_MT4_CREDIT_REPORT', link: '/mt4CreditReport', icon: 'fa fa-credit-card', childrenLink: [] },
        { text: sider.mt4SummaryReport, id: 'FN_MT4_SUMMARY_REPORT', link: '/mt4SummaryReport', icon: 'fa fa-pie-chart', childrenLink: [] },
        { text: sider.mt4SeregatedReport, id: 'FN_MT4_SEREGATED_REPORT', link: '/mt4SeregatedReport', icon: 'fa fa-exchange', childrenLink: [] },
        { text: sider.mt4EquityReport, id: 'FN_MT4_EQUITY_REPORT', link: '/mt4EquityReport', icon: 'fa fa-usd', childrenLink: [] },
        { text: sider.mt4EquityMultiReport, id: 'FN_MT4_EQUITY_MULTI_REPORT', link: '/mt4EquityMultiReport', icon: 'fa fa-usd', childrenLink: [] },
        { text: sider.mt4ProfitLossReport, id: 'FN_MT4_PROFIT_AND_LOSS_REPORT', link: '/mt4ProfitLossReport', icon: 'fa fa-balance-scale', childrenLink: [] },
        { text: sider.mt4AccountReport, id: 'FN_MT4_ACCOUNT_REPORT', link: '/mt4AccountReport', icon: 'fa fa-user', childrenLink: [] },
        { text: sider.userMaintenance, id: 'FN_USER_MAINTENANCE', link: '/userMaintenance', icon: 'fa fa-user-circle-o', childrenLink: ['/userEdit', '/addUser'] },
        { text: sider.roleMaintenance, id: 'FN_ROLE_MAINTENANCE', link: '/roleMaintenance', icon: 'fa fa-user-circle', childrenLink: ['/addRole', '/roleEdit'] },
        { text: sider.auditLog, id: 'FN_AUDIT_LOG', link: '/auditLog', icon: 'fa fa-pencil-square-o', childrenLink: [] },
        { text: sider.changePassword, id: 'FN_CHANGE_PASSWORD', link: '/changePassword', icon: 'fa fa-cog', childrenLink: [] },
      ]
    },
    user() {
      // 当前登录的user
      return JSON.parse(sessionStorage.user)
    },
    activeItem() {
      // crumbs所需要的当前活动的侧边导航信息
      let obj = {
        ct: '',
        cicon: '',
      }
      for (let item of this.fnList) {
        if (item.id == this.currentSideBar) {
          obj.ct = item.text
          obj.cicon = item.icon
          break
        }
      }
      return obj
    },
    viewReadOnly() {
      // 当前页面是否只读
      for (let item of this.responseFnlist) {
        if (this.currentSideBar === item.functionID) return item.readOnly
      }
      return false
    },
    managerAccount() {
      return this.managerLogin
    },
    desc() {
      const current = this.mainViewLan.currentManLogin
      const exit = this.mainViewLan.exit
      return { current, exit }
    },
  },
  methods: {
    getFunctionList() {
      // 获取fnList
      this.$http.get(URL_LIST).then((res) => {
        this.responseFnlist = res.data.data
        if (this.user.isSuper == true) {
          // 如果 后台返回空数组表示改角色拥有全部function
          this.allList = true
          this.fnListKeys = []
          if (this.$route.path !== '/mainView') this.handleChangeUrl(this.$route.path) // 判断是否是授权页面
          if (!sessionStorage.curSideBar) {
            // 如果sessionStorage.curSideBar 为空时，则默认保存，第一个被授权的，侧边导航为，当前选中的导航
            this.saveSideBar(this.fnList[0].id, this.fnList[0].link)
          } else {
            // 否则就选中 sessionStorage.curSideBar 里面保存的导航
            this.currentSideBar = sessionStorage.curSideBar
          }
        } else if (this.user.isSuper == false) {
          // 否则 遍历该数组去掉重复项
          this.allList = false
          let obj = {}
          for (let item of res.data.data) {
            if (!obj[item.functionID]) {
              this.fnListKeys.push(item.functionID)
              obj[item.functionID] = 1
            }
          }
          if (this.$route.path !== '/mainView') this.handleChangeUrl(this.$route.path) // 判断是否是授权页面
          if (!sessionStorage.curSideBar) {
            // 如果sessionStorage.curSideBar 为空时，则默认保存，第一个被授权的，侧边导航为，当前选中的导航
            let enableFnList = this.fnList.filter((v) => this.fnListKeys.includes(v.id))
            this.saveSideBar(enableFnList[0].id, enableFnList[0].link)
          } else {
            // 否则就选中 sessionStorage.curSideBar 里面保存的导航
            this.currentSideBar = sessionStorage.curSideBar
          }
        }
      })
    },
    saveSideBar(item, link = false) {
      // 保存当前侧边导航，并跳转到新的路由地址
      sessionStorage.curSideBar = item
      this.currentSideBar = item
      link && this.$router.push(link)
    },
    handleChangeUrl(link) {
      // 处理在浏览器地址栏输入url时,判断是否是授权页面
      for (let fn of this.fnList) {
        if (link === fn.link && (this.fnListKeys.includes(fn.id) || this.allList)) return this.saveSideBar(fn.id)
      }
      for (let fn of this.fnList) {
        if (fn.childrenLink.includes(link) && (this.fnListKeys.includes(fn.id) || this.allList)) return this.saveSideBar(fn.id)
      }
      //this.$router.push("/unenabled");
    },
    logoutFn() {
      this.$http.post(URL_LOGOUT)
      this.$router.push('/login')
    },
    getManLogin() {
      const jwt = sessionStorage.getItem('token')
      if (!jwt) return jwt
      const str = decodeURIComponent(escape(window.atob(jwt.split('.')[1])))
      return JSON.parse(str).login.toString()
    },
    exit() {
      sessionStorage.removeItem('token')
      this.$router.push({
        path: '/managerAuth',
        query: { nextUrl: this.$route.fullPath },
      })
    },
    getMT4Timezone() {
      this.$http.get(URL_TIMEDIFF).then((res) => {
        sessionStorage.setItem('MT4TimeZone', res.data.data.diff)
      })
    },
  },
  watch: {
    $route(newRoute) {
      this.managerLogin = newRoute.meta.showInCrumb ? this.getManLogin() : ''
    },
  },
  created() {
    if (this.user && this.user !== 'undefined') {
      if (!sessionStorage.getItem('MT4TimeZone')) this.getMT4Timezone()
      this.getFunctionList()
      this.managerLogin = this.$route.meta.showInCrumb ? this.getManLogin() : ''
    }
  },
}
</script>

<style lang="scss" scoped>
.section {
    display: -webkit-box;
    .side-bar {
        min-width: 18%;
        min-height: 901px;
        background: #fff;
        border-right: 1px solid #ddd;
        ul li {
            padding: 12px 20px;
            cursor: pointer;
            margin-bottom: 1px;
            > i {
                float: left;
                margin-top: 2px;
                margin-right: 15px;
                font-size: 16px;
            }
        }
        ul li:hover {
            background-color: rgba(0, 0, 0, 0.1);
            color: #333;
        }
    }
    .content-view {
        flex:1
    }
    .cur-bg {
        background-color: rgba(0, 0, 0, 0.1);
        color: #333;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/mainView.vue